<template>
<div class="chapter">
<div class="inner_page">
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td class="border2" style="width:10%" valign="middle"><h2 class="h2"><a id="page_1"></a><a id="part1"></a>PART<br/>ONE</h2></td>
<td style="width:80%" valign="top"><h2 class="h2a">Blessed by<br/>Experiences</h2></td>
</tr>
<tr>
<td class="border" valign="top"><h2 class="h2a"> </h2></td>
<td valign="top"><p class="blockquotex"><em>“Clyburn,” she asked, “how did you vote in this primary?” It was quite a question. But, given the weightiness of the previous half-hour’s conversation, I was prepared. I looked at Emily, took a deep breath and said, “How could I ever look in the faces of our children and grandchildren had I not voted for Barack Obama?”</em></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?f1d5b90a